module.exports = __webpack_public_path__ + "img/email_section_img.21f847d3.jpg";